import React, { Component } from 'react';
import StreamPlayer from '../Stream/StreamPlayer/StreamPlayer';
import PropTypes from "prop-types";
import coverTheater from '../../images/cover-theater.jpg';

class StreamLaunch extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    };

    render() {
        return (
            <React.Fragment>
                <div className="showtix-stream">
                    <div className="showtix-section showtix-stream__wrapper" style={{backgroundImage: "url(" + coverTheater + ")"}}>
                        <div className="container showtix-stream__content">
                            <div className="row mb-4">
                                <div className="col-12 text-center">
                                    <StreamPlayer
                                        streamConfig={{
                                            vimeo_video_id: '425254956'
                                        }}
                                    ></StreamPlayer>
                                </div>
                            </div>
                        </div>
                    </div>
                    <style dangerouslySetInnerHTML={{__html: `
                        .stream-player-initialized .zopim {
                            display: none !important;
                        }
                    `}} />
                </div>
            </React.Fragment>
        );
    }
}

StreamLaunch.propTypes = {};

export default StreamLaunch;


// WEBPACK FOOTER //
// ./src/components/StreamLaunch/StreamLaunch.js